import { createStore } from "vuex";

import wood from "./modules/wood.js";

export default createStore({
  state: {
    beforeRoute: null
  },
  mutations: {
    changeBeforeRoute(state, route) {
      state.beforeRoute = route;
    }
  },
  actions: {
    changeBeforeRoute({commit}, route) {
      commit("changeBeforeRoute", route);
    }
  },
  modules: {
    wood
  }
});
